import Vue from "vue";

class PermissionService {

    isValid(permission) {
        const token = JSON.parse(localStorage.getItem("user-token")) || ""
        let permissao = token?.permissoes || [];
        return permissao.filter((x) => x === permission).length > 0;
    }

    isValidAndShowMessage(permission) {
        const valid = this.isValid(permission);
                if (!valid)
            this.showMessage(["Você não possui permissão para executar essa ação.", "Solicite permissão ao administrador."]);

        return valid;
    }

    showMessage(message) {
        var show = Array.isArray(message) ? message : [message];
        Vue.prototype.$notify({
            data: show ,
            type: "warn",
            duration: 5000
        });
    }

}

export default new PermissionService();
